import { PublicLink } from "../constants/definitions";
import { ChildToManyParentsRelation } from "../contracts/base/relations/child-to-many-parents-relation";
import Guard from "../guard";
import { IExtendedContentHubClient } from "./extended-client";

/**
 * Allows fetching culture information.
 */
export interface IAssetsClient {
    /**
     * Gets the default culture.
     * @returns The default culture.
     */
    createPublicLinkAsync(
        assetId: number,
        rendition: string,
        expirationDate?: Date,
        relativeUrl?: string
    ): Promise<number>;
}

export class AssetsClient implements IAssetsClient {
    private readonly _client: IExtendedContentHubClient;
    constructor(client: IExtendedContentHubClient) {
        Guard.notNull(client);

        this._client = client;
    }

    async createPublicLinkAsync(
        assetId: number,
        rendition: string,
        expirationDate?: Date,
        relativeUrl?: string
    ): Promise<number> {
        Guard.validId(assetId);
        Guard.stringNotNullOrEmpty(rendition);

        const publicLink = await this._client.entityFactory.createAsync(PublicLink.definitionName);

        publicLink.setPropertyValue(PublicLink.resource, rendition);

        if (expirationDate) {
            publicLink.setPropertyValue(PublicLink.expirationDate, expirationDate);
        }

        if (relativeUrl) {
            Guard.stringNotNullOrEmpty(relativeUrl);

            publicLink.setPropertyValue(PublicLink.relativeUrl, relativeUrl);
        }

        const assetToPublicLink = publicLink.getRelation(PublicLink.assetToPublicLink) as ChildToManyParentsRelation;
        assetToPublicLink?.add(assetId);

        return this._client.entities.saveAsync(publicLink);
    }
}
